import '../Layout/Layout.scss'
import AnimatedLetters from '../AnimatedLetters/AnimatedLetters'
import { useState, useEffect, Fragment } from 'react'
import Loader from 'react-loaders'
import Pglife from '../../assets/images/pglife-index.png'
import foodOrder from '../../assets/images/food_order.png'
import CreativeTrading  from '../../assets/images/creative-trading.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCode, faDesktop } from '@fortawesome/free-solid-svg-icons'
import './Projects.scss'

function Projects() {
  const [letterClass, setLetterClass] = useState('text-animate')

  //   effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)

    return () => {
      clearTimeout(timer)
    }
  }, [])

  return (
    <Fragment>
      <div className="container projects-page">
        <h1 className="page-title">
          <AnimatedLetters
            letterClass={letterClass}
            strArray={['M', 'y', ' ', 'P', 'r', 'o', 'j', 'e', 'c', 't', 's']}
            idx={15}
          />
        </h1>
        <div id="projects-container">
          <div className="project">
            <img style={{transform:'scale(1.2)'}} src={CreativeTrading}></img>
            <div className="project-description">
              <h2>Creative Trading</h2>
              <p>
                Creative Trading is dynamic react project, providing the capability of overviewing and monitoring your favourite stock with just a few clicks. The project offers real time fluctuations and historical data for the chosen stock.<br/>

                <br/><b>Note</b>: While exploring the Creative-Trading demo, please make sure to only choose stocks NOT possessing any extensions (.ME, .MS, .NI etc) as they are beyond the free stock quotes offered by finnHub API.
                The project only display US stocks at the moment because of me being unable to procure any free Indian stock tracking API.
              </p>
              <p> Demo Status : Available</p>
              <h2>Technologies and Libraries used : </h2>
              <p>ReactJS , Axios fetch API , Context API , finnHub API(free) ApexCharts , Bootstrap</p>
              <span id="source">
                <a href='https://github.com/AnshNJ/Creative-Trading' target='_blank'><FontAwesomeIcon id="icons" icon={faCode} /></a>
                <a href='http://creative-trading.netlify.app' target='_blank'><FontAwesomeIcon id="icons" icon={faDesktop} /></a>
              </span>
            </div>
          </div>
          <span id="divider" />
          <div className="project" style={{ flexDirection: 'row-reverse' }}>
            <img style={{transform:'scale(1.2)'}} src={foodOrder}></img>
            <div className="project-description">
              <h2>React Meals</h2>
              <p>
                An interactive and responsive food ordering App made from the
                bottom up using ReactJS fundamentals. The page includes
                real-time item renewals, cart updates and monetary calculation.
              </p>
              <p> Demo Status : Available</p>
              <h2>Technologies and Libraries used : </h2>
              <p>ReactJS , CSS3, ContextAPI, FetchAPI</p>
              <span id="source">
                <a href='https://github.com/AnshNJ/Food-Order-App' target='_blank'>
                  <FontAwesomeIcon id="icons" icon={faCode} />
                </a>
                <a
                  href="https://food-order-app-gilt.vercel.app/"
                  target="_blank"
                >
                  <FontAwesomeIcon id="icons" icon={faDesktop} />
                </a>
              </span>
            </div>
          </div>
          <span id="divider" />
          <div className="project">
            <img src={Pglife}></img>
            <div className="project-description">
              <h2>PGLife</h2>
              <p>
                PGLife is a responsive and interactive website designed to help
                students and/or working individuals look for rented rooms at the
                comfort of their home. The website provides all necessary
                details such as rent, amenities, photo references, testimonials,
                etc. to help improve customer interaction.
              </p>
              <p> Demo Status : Available</p>
              <h2>Technologies and Libraries used : </h2>
              <p>HTML5 , CSS3 , Javascript , PHP , DBMS , Bootstrap</p>
              <span id="source">
                <a href='https://github.com/AnshNJ/PGLife'><FontAwesomeIcon id="icons" icon={faCode} /></a>
                <a href='http://pg-life-demo.netlify.app' target='_blank'><FontAwesomeIcon id="icons" icon={faDesktop} /></a>
              </span>
            </div>
          </div>
        </div>{' '}
        <div className="alternative-projects">
          <h1>Alternate Projects</h1>
          <div className="alt-project-container">
            <div className="alt-projects">
              <h2>TO-DO List</h2>
              <p>
                An interactive TO-DO list made using <span>React</span>{' '}
                functional components, including features such as :
              </p>
              <ul>
                <li>Real-Time list update/removal</li>
                <li>Filter based on year</li>
                <li>Dynamic graph to improve user experience</li>
              </ul>
              <span id="source">
                <FontAwesomeIcon id="icons" icon={faCode} />
              </span>
            </div>

            <div className="alt-projects">
              <h2>Black - Jack</h2>
              <p>
                Black-Jack game developed using <span>Python</span> offering
                playability to one or more players with computer as the dealer.
              </p>
              <ul>
                <li>Multiple player support</li>
                <li>Actual gameplay functionalities such as Hit or Stand</li>
                <li>Player bank managing player's balance.</li>
              </ul>
              <span id="source">
                <FontAwesomeIcon id="icons" icon={faCode} />
              </span>
            </div>

            <div className="alt-projects">
              <h2>Tic-Tac-Toe</h2>
              <p>
                A turn based Tic-Tac-Toe game developed for two players using{' '}
                <span>Python</span> including features such as :
              </p>
              <ul>
                <li>Replayability</li>
                <li>Ability to choose turns and/or Markers</li>
              </ul>
              <span id="source"><a href='https://github.com/AnshNJ/My-projects/blob/main/Tic%20Tac%20Toe%20(Player%20v%20Player)%20(Moderate)' target='_blank'>
                <FontAwesomeIcon id="icons" icon={faCode} /></a>
              </span>
            </div>
          </div>
        </div>
      </div>

      <Loader type="pacman" />
    </Fragment>
  )
}

export default Projects
